export const zeroPad = (num) => `${num < 10 ? '0' : ''}${num}`;
